import { TaughtLessonAssignment } from './class-stats.types';

export type AssignmentPayload = {
  businessKey: string;
  createdDate: number;
  lastUpdated: number;
  startDate?: number;
  dueDate?: number;
  districtKey?: string;
  creatorBk: string;
  classBks: string[];
  assignedContent: AssignedContent[];
  studentStatuses?: StudentStatus[];
  enrollmentType?: string;
};

export type AssignmentResponseHeaders = {
  'assignment-available-domains': string;
  'assignment-total-count': string;
};

export type AssignmentResponseWithHeaders = {
  data: AssignmentPayload[];
  headers: AssignmentResponseHeaders;
};

export type AssignedContent = {
  contentBusinessKey: string;
  content: CurriculumAssignmentContent | DesmosAssignmentContent;
  type?: string;
  metadata?: {
    ismCLASSAssessment?: boolean;
  };
};

export type StudentStatus = {
  studentBusinessKey: string;
  createdDate: number;
  status: AssignmentStatus;
  contentStatuses?: Array<{
    status: AssignmentStatus;
    contentBusinessKey: string;
  }>;
};

export type PlaceholderAssignment = {
  assignmentBk: string;
  assignmentClassBks: Array<string>;
  contentBk: string;
  createdDate: number;
  startDate: number | null;
  status: AssignmentStatus;
  lastUpdated: number;
  dueDate: number | null;
  enrollmentType?: string;
  isHandedInmCLASSAssessment?: boolean;
};

export type SingleAssignment = PlaceholderAssignment & {
  type: 'Lesson';
  content: CurriculumAssignmentContent;
  dueDate?: number;
};

export type DesmosAssignment = PlaceholderAssignment & {
  type: 'Lesson';
  content: DesmosAssignmentContent;
  dueDate?: number;
};

export type CardstackAssignment = PlaceholderAssignment & {
  type: 'Cardstack';
  content: CurriculumAssignmentContent[];
  dueDate: number | null;
  studentStatuses?: StudentStatus[];
};

export type Assignment =
  | SingleAssignment
  | DesmosAssignment
  | CardstackAssignment
  | TaughtLessonAssignment;

export type AssignmentsObject = {
  assignments: Assignment[];
  assignmentsTotalCount?: string;
  assignmentDomains?: string;
};

export type CustomContentId = string | null;

export type CurriculumAssignmentContent = {
  cardstackKey?: string;
  cardstackTitle?: string;
  cardstackOrdinalNumber?: number;
  cardstackStatus?: AssignmentStatus;
  chapterKey?: string;
  chapterTitle?: string;
  contentBusinessKey?: string;
  lessonKey?: string;
  lessonTitle?: string;
  title?: string;
  unitKey?: string;
  customContentId?: CustomContentId;
  unitRevision?: string;
  unitRevisionAlias?: string;
  unitTitle?: string;
  domain?: string;
  subject?: string;
  lessonThumbnailImagePath?: string;
  isSubmittable?: boolean;
  isCurriculumCustomContent?: boolean;
};

export type DesmosAssignmentContent = {
  id?: string;
  creationDate?: string;
  contentType?: string;
  dashboardURL?: string;
  title?: string;
  subtitle?: string;
  classCode?: string;
  activityId?: string;
  thumbURL?: string;
  activityLandingPageURL?: string;
  studentURL?: string;
  studentJoinURL?: string;
  studentGreetingURL?: string;
  domain?: string;
  subject?: string;
};

export type ContentStatus = {
  status: AssignmentStatus;
  contentBusinessKey: string;
};

export type AssignmentUpdatePayload = {
  studentBusinessKey: string;
  assignmentBusinessKey: string;
  status: AssignmentStatus;
  contentStatuses: ContentStatus[];
};

export type AssignmentColorProps = {
  item: string;
  img: string;
  date: string;
};

export enum AssignmentStatus {
  TODO = 'TODO',
  READ = 'READ',
  HANDED_IN = 'HANDED IN',
  STARTED = 'STARTED',
}

export enum AssignmentsViewOptions {
  TODO = 'TODO',
  PAST_WORK = 'PAST WORK',
  APPS = 'APPS',
}

export enum AssignmentsWorkTypeMap {
  TODO = 'TODO',
  PAST_WORK = 'PAST',
}

export enum MSAssignmentsStatusOptions {
  NOT_STARTED = 'TODO,NOT STARTED',
  STARTED = 'READ,STARTED',
  HANDED_IN = 'HANDED IN',
}
